<template>
	<v-card
		hover
		@click="$emit('click')"
		class="mx-auto"
		:class="!noColor ? 'opaqueBlueBg' : ''"
		rounded
		outlined
		:dark="!noColor"
	>
		<!-- :color="noColor ? '' : opaqueBlueBg" -->
		<v-list-item>
			<v-list-item-avatar>
				<v-icon>{{ fileIcon }}</v-icon>
			</v-list-item-avatar>
			<v-list-item-content>
				<v-list-item-title v-text="name" />
				<v-list-item-subtitle v-text="filetype" />
			</v-list-item-content>
		</v-list-item>
	</v-card>
</template>

<script>
import FileIcons from '@/helpers/file-icons'

export default {
	name: 'FileItem',
	props: {
		name: String,
		path: String,
		filetype: String,
		noColor: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		fileIcon() {
			return FileIcons[this.filetype] || FileIcons['default']
		},
	},
}
</script>

<style lang="scss" scoped>
.v-list-item__content {
	display: block;
}
</style>
